import React from 'react';
import { SIcon } from '@avalara/skylab-sdk/react';
import { ExtractorActiveTierCheckMark, ExtractorPickerButtonContainer, ExtractorPickerInfo, PickerInfoContainer, ExtractorPickerPrice, ExtractorPickerQuantity, TierPlanButton, } from '../../styled/components/buy-flow';
const TierComponent = ({ onSelectProduct, selectedProduct, tier, title, frequency, isSupportTile, }) => {
    let tierButton;
    let priceMessage;
    let selected = false;
    let tmpTier = { id: 'support', tierNumber: undefined, quantity: 0 };
    if (isSupportTile) {
        tierButton = React.createElement(React.Fragment, null,
            React.createElement("p", null, "Call to learn more"),
            React.createElement("a", { href: 'tel://(877) 224-3650', style: { color: 'var(--color-blue-darker)' } }, "(877) 224-3650"));
        priceMessage = 'Avalara has plans for any size business.';
    }
    else if (tier) {
        selected = Boolean(selectedProduct && selectedProduct.quantity === tier.quantity);
        [priceMessage] = tier.recurringPrice.toLocaleString('en-US', { style: 'currency', currency: 'USD' }).split('.');
        if (selected) {
            tierButton = React.createElement(TierPlanButton, { className: 'active ghost' },
                React.createElement(ExtractorActiveTierCheckMark, null,
                    React.createElement(SIcon, { name: 'check' })));
        }
        else {
            tierButton = React.createElement("button", { id: `button-${tier.quantity}`, className: 'default primary', onClick: () => onSelectProduct(tier) }, "Select");
        }
        tmpTier = tier;
    }
    return (React.createElement(PickerInfoContainer, { id: `${tmpTier.id}tier${tmpTier.tierNumber}` },
        React.createElement(ExtractorPickerInfo, { selected: selected },
            React.createElement(ExtractorPickerQuantity, null,
                React.createElement("p", null,
                    title.pre || '',
                    React.createElement("strong", null, title.emp || ''),
                    title.end || '')),
            React.createElement(ExtractorPickerPrice, { peryear: frequency ? `paid ${frequency}` : undefined, isSupportTile: isSupportTile },
                React.createElement("p", { className: `tierPriceFor${tmpTier.quantity}` }, priceMessage)),
            React.createElement(ExtractorPickerButtonContainer, { isSupportTile: isSupportTile }, tierButton))));
};
export default TierComponent;
